<template>
  <v-container>
    <v-row>
      <h4 class="title">List of support tickets</h4>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-data-table :headers="headers" :items="list" :items-per-page="15">
          <template v-slot:item.message="{ item }">
            {{ item.message | truncate(50) }}
          </template>

          <template v-slot:item.createdTime="{ item }">
            {{ item.createdTime | formatDateTime }}
          </template>

          <template v-slot:item.id="{ item }">
            <router-link :to="'view/' + item.id"> {{ item.id }}</router-link>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      headers: [
        {
          text: 'From',

          value: 'email'
        },
        { text: 'Message', value: 'message' },
        { text: 'Date', value: 'createdTime' },

        { text: 'View', value: 'id' }
      ],
      list: []
    }
  },
  mounted() {
    this.$store.dispatch('loadSupportTickets').then(list => {
      if (list) {
        list.forEach(d => {
          this.list.push({ ...d.data(), id: d.id })
        })
      }
    })
  }
}
</script>
